exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".center[data-v-3657f4bc]{align-self:center}.prefix[data-v-3657f4bc]{margin-bottom:25px}.help-btn[data-v-3657f4bc]{background-color:var(--v-helpColor-base);color:var(--v-helpTextColor-base);display:flex;justify-content:center;align-items:center;width:24px;height:24px;border-radius:100%;padding-top:2px;font-weight:700}.help-btn[data-v-3657f4bc]:hover{background-color:var(--v-activeHelpColor-base);color:var(--v-activeHelpTextColor-base)}.help-btn-pos[data-v-3657f4bc]{margin-top:30px;transform:translateY(-50%)}", ""]);

// exports
